import {
  AccessRegister,
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { AxiosResponse } from "axios";
import { TSiteLoginContentForm } from "./SiteLoginContentSchema";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";

const translationPath = "page.4uSiteApp.siteLoginContent.";

const SiteLoginContentLanguage = ({
  name,
  index,
  service,
  loadDefaultLang,
}: {
  name: string;
  index: number;
  service: (params?: any) => Promise<AxiosResponse<ISelectType[]>>;
  loadDefaultLang: (lang: ISelectType) => void;
}) => {
  const { control } = useFormContext<TSiteLoginContentForm>();
  const [languageOptions, setLanguageOptions] = useState<ISelectType[]>([]);
  const { t } = useTranslation();

  const { sendRequest } = useFetch(service);

  const selectedLanguage = useWatch({
    name: "siteLoginContentLanguages",
    control,
  });

  const loadLanguageOptions = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);
    if (data && success) {
      const selectedLang = selectedLanguage.find(
        (lang, indexLang) => indexLang === index
      );
      const filteredOptions = data.filter(
        (option) =>
          !selectedLanguage.some(
            (selected) => selected.language?.id === option.id
          )
      );
      loadDefaultLang(filteredOptions[0]);
      if (selectedLang?.language && filteredOptions.length !== 0) {
        setLanguageOptions([...filteredOptions, selectedLang.language]);
      } else {
        setLanguageOptions(filteredOptions);
      }
    }
  }, [sendRequest, loadDefaultLang, selectedLanguage, index]);

  useEffect(() => {
    loadLanguageOptions();
  }, [loadLanguageOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AccessRegister
        redirectTo="dashboard/globals/languages"
        domainName="language"
        inputValue={
          selectedLanguage[index].language
            ? [
                {
                  id: selectedLanguage[index].language!.id,
                  name: selectedLanguage[index].language!.name,
                },
              ]
            : []
        }
        tooltip={t(translationPath + "language_tooltip")}
      >
        <AutoComplete
          label={t(translationPath + "language") || "Language"}
          name={name}
          size="small"
          getOptionLabel={(option) => {
            return option.name;
          }}
          options={languageOptions}
          filterSelectedOptions
        />
      </AccessRegister>
    </Grid>
  );
};

export default SiteLoginContentLanguage;
